import { Component, OnInit } from '@angular/core';
import { BatchOperation } from 'src/app/def/types';
import { Utente } from 'src/app/def/structures';
import { DBFirestoreService } from 'src/app/dbfirestore.service';

@Component({
    selector: 'odl-admin-utenti',
    templateUrl: './utenti.component.html',
    styleUrls: ['./utenti.component.scss']
})
export class OdlAdminUtentiComponent implements OnInit {

    utenti: Utente[] = [];
    newutenti: Partial<Utente>[] = [];
    newrow: Partial<Utente> = {
        nome: '',
        cognome: ''
    }

    batchops: BatchOperation[] = [];
    toDelete: string[] = [];
    constructor(
        private db: DBFirestoreService
    ) { }

    ngOnInit() {
        this.db.collectionUtenti(true).subscribe( utenti => this.utenti = utenti );
    }

    addNew() {
        if ( !this.newrow.nome || !this.newrow.cognome) {
            return;
        }
        this.newutenti.push({
            nome: this.newrow.nome,
            cognome: this.newrow.cognome,
            disabled: false,
        })
        this.newrow.nome = '';
        this.newrow.cognome = '';

        this.commit();
    }

    delete(utente) {
        if ( !confirm('Questa operazione eliminerà in modo permanente l\'utente. Piuttosto che cancellarlo, è consigliabile disattivarlo per non perdere l\'associazione con gli ordini inseriti.'+"\n\n"+' Sei sicuro di voler procedere?') ) {
            return;
        }
        console.log(utente);
        this.db.deleteUtente(utente).then( () => {
            console.log('deleted');

        }).catch( error => {
            this.onError('errore cancellazione utente', error)
        });
    }

    disable(utente) {
        utente.disabled= true;
        this.db.updateUtente(utente).catch( error => {
            alert('Operazione non riuscita');
            console.log(error);
        })
    }

    enable(utente) {
        utente.disabled= false;
        this.db.updateUtente(utente).catch( error => {
            alert('Operazione non riuscita');
            console.log(error);
        })
    }

    delNew(idx) {
        this.utenti.splice(idx,1);
    }

    
    commit() {
        this.addNew();
        this.batchops = [];
        this.batchops = this.newutenti.map( utente => {
            return this.db.batchAddUtente({
                id: null,
                nome: utente.nome,
                cognome: utente.cognome,
                disabled: false,
            });
        });
        this.db.batch(this.batchops).then( result => {
            this.batchops = [];
        }).catch( error => {
            this.onError('Errore procedura di aggiornamento', error)
        });
    }

    onError(title: string, extra: any) {
        alert(title);
        console.log(extra);
    }
}
